import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PayrollItemEmployee } from './payroll-item-employee.model';
import * as PayrollItemEmployeeActions from './payroll-item-employee.actions';

export const payrollItemEmployeesFeatureKey = 'payrollItemEmployees';

export interface State extends EntityState<PayrollItemEmployee> {
    // additional entities state properties
}

export const adapter: EntityAdapter<PayrollItemEmployee> = createEntityAdapter<PayrollItemEmployee>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const payrollItemEmployeeReducer = createReducer(
    initialState,
    on(PayrollItemEmployeeActions.addPayrollItemEmployee, (state, action) =>
        adapter.addOne(action.payrollItemEmployee, state)
    ),
    on(PayrollItemEmployeeActions.upsertPayrollItemEmployee, (state, action) =>
        adapter.upsertOne(action.payrollItemEmployee, state)
    ),
    on(PayrollItemEmployeeActions.addPayrollItemEmployees, (state, action) =>
        adapter.addMany(action.payrollItemEmployees, state)
    ),
    on(PayrollItemEmployeeActions.upsertPayrollItemEmployees, (state, action) =>
        adapter.upsertMany(action.payrollItemEmployees, state)
    ),
    on(PayrollItemEmployeeActions.updatePayrollItemEmployee, (state, action) =>
        adapter.updateOne(action.payrollItemEmployee, state)
    ),
    on(PayrollItemEmployeeActions.updatePayrollItemEmployees, (state, action) =>
        adapter.updateMany(action.payrollItemEmployees, state)
    ),
    on(PayrollItemEmployeeActions.deletePayrollItemEmployee, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(PayrollItemEmployeeActions.deletePayrollItemEmployees, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(PayrollItemEmployeeActions.loadPayrollItemEmployees, (state, action) =>
        adapter.setAll(action.payrollItemEmployees, state)
    ),
    on(PayrollItemEmployeeActions.clearPayrollItemEmployees, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return payrollItemEmployeeReducer(state, action);
}
